import * as React from 'react';

import {BulletedList} from 'shells/bulleted-list/bulleted-list';
import {OnboardingBody} from 'shells/onboarding-page/onboarding-body';

export function BuiltIntoCRM() {
    return (
        <OnboardingBody title='Built into your CRM'>
            <p>
                Scheduler is a part of Nutshell, providing you with the unique advantage of
                collecting data directly into your CRM, unlike tools such as Calendly.
            </p>
            <BulletedList
                bullets={[
                    <span key='1'>
                        Choose which fields your invitees complete, including custom fields
                    </span>,
                    <span key='2'>Effortlessly manage and access invitee information</span>,
                    <span key='3'>
                        Automatically generate activities with the appropriate activity type
                    </span>,
                ]}
            />
        </OnboardingBody>
    );
}
